import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

const isTestCaseSimulatorEnabledQuery = gql`
  query isTestCaseSimulatorEnabledQuery {
    isTestCaseSimulatorEnabled
  }
`;

type UseIsTestCaseSimulatorEnabledOutput = {
  error: string | undefined;
  isEnabled: boolean;
  isLoading: boolean;
};

export const useIsTestCaseSimulatorEnabled = (): UseIsTestCaseSimulatorEnabledOutput => {
  const { loading, data, error } = useQuery(isTestCaseSimulatorEnabledQuery);

  return {
    error: error ? 'Error loading Test Case Simulator data.' : undefined,
    isEnabled: data?.isTestCaseSimulatorEnabled,
    isLoading: loading,
  };
};
